// src/runtime.js

// Extract tenant ID from hostname:
// Domain looks like: form-renderer-1000222.heliumapp.com
function getTenantIdFromHost() {
  const host = window.location.hostname; 
  // Example: "form-renderer-1000222.heliumapp.com"

  const [subdomain] = host.split(".");
  // "form-renderer-1000222"

  const match = subdomain.match(/-(\d+)$/);
  // match[1] = "1000222"

  return match ? match[1] : null;
}

const mode = process.env.NODE_ENV; // "development", "production", "test"

let tenantId = null;
let apiEndpoint = "";

// --- Production Mode ---
if (mode === "production") {
  tenantId = getTenantIdFromHost();

  if (tenantId) {
    apiEndpoint = `https://${tenantId}-api.heliumapp.com`;
  } else {
    // If tenant ID is missing in prod, fallback to env (for safety)
    apiEndpoint = process.env.REACT_APP_API_URL || "";
  }
}

// --- Development / Local Mode ---
else {
  apiEndpoint = process.env.REACT_APP_API_URL || "";
}

export const RUNTIME_CONFIG = {
  tenantId,
  apiEndpoint,
};
